import { render, staticRenderFns } from "./pre-banner-appearance-card.vue?vue&type=template&id=35f66fa2"
import script from "./pre-banner-appearance-card.vue?vue&type=script&lang=js"
export * from "./pre-banner-appearance-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports